import React from 'react';

const SelectionModeOverlay = ({
  selectedMessages,
  onCancel,
  onSave
}) => {
  return (
    <div className="fixed bottom-24 right-6 z-50 flex flex-col items-end gap-3">
      <div className="bg-white dark:bg-gray-800 text-gray-900 dark:text-white px-4 py-2 rounded-full shadow-lg border border-gray-200 dark:border-gray-700">
        <span className="text-sm font-medium">
          {selectedMessages.length} message{selectedMessages.length !== 1 ? 's' : ''} selected
        </span>
      </div>
      
      <div className="flex gap-2">
        <button
          onClick={onCancel}
          className="px-4 py-3 rounded-full bg-gray-500 text-white hover:bg-gray-600 transition-colors shadow-lg min-h-[48px] flex items-center justify-center font-medium"
          title="Exit selection mode"
        >
          Cancel
        </button>
        <button
          onClick={onSave}
          disabled={selectedMessages.length === 0}
          className={`px-6 py-3 rounded-full min-h-[48px] flex items-center justify-center font-medium shadow-lg transition-colors ${
            selectedMessages.length > 0 
              ? 'bg-green-500 text-white hover:bg-green-600' 
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
          title={selectedMessages.length > 0 ? 'Save selected messages to Library' : 'Select at least one message'}
        >
          Save to Hub
        </button>
      </div>
      
      {selectedMessages.length === 0 && (
        <div className="bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 text-xs px-3 py-2 rounded-lg shadow-md max-w-[250px] text-center">
          Select messages to save to Library
        </div>
      )}
    </div>
  );
};

export default SelectionModeOverlay;
